import is from '@sindresorhus/is';
import { useCallback } from 'react';

import { useOptionalCommentsScope } from '../comments-scope-context';
import { commentsGroupMemberIdFor, useOptionalCommentsGroupStoreApi } from '../group';
import { useRequestCommentsOpen } from '../surface/comments-open-request-context';
import type { CommentTarget } from '../types';

export type OpenGroupThread = (threadId: string, target: CommentTarget) => void;

// Row clicks inside a member tile are the second entry point into the group comment tile next
// to the parent's toggle: they reveal the tile when it is closed and activate the clicked
// thread. Group members register on mount, so the activation lands whether the tile is open or
// not and the tile picks it up as it appears.
export const useOpenGroupThread = (): OpenGroupThread => {
    const store = useOptionalCommentsGroupStoreApi();
    const scope = useOptionalCommentsScope();
    const requestCommentsOpen = useRequestCommentsOpen();
    const memberKind = scope?.kind;
    const subjectId = scope?.itemId;

    return useCallback(
        (threadId, target) => {
            if (is.null(store) || is.undefined(memberKind) || is.undefined(subjectId)) {
                return;
            }

            requestCommentsOpen();
            store.getState().activateThread({
                memberId: commentsGroupMemberIdFor({ kind: memberKind, subjectId }),
                target,
                threadId,
            });
        },
        [memberKind, requestCommentsOpen, store, subjectId],
    );
};
